import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 20000;

const apiUrl = process.env.VUE_APP_API_URL || '';
if (apiUrl) {
  axios.defaults.baseURL = apiUrl;
}

function clearAdminLoginMark() {
  localStorage.removeItem('adminLoggedIn');
}

function attachAuthInterceptor(client) {
  client.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response && err.response.status === 401) {
        clearAdminLoginMark();
      }
      return Promise.reject(err);
    }
  );
}

attachAuthInterceptor(axios);

export function createApiClient(config = {}) {
  const client = axios.create({
    withCredentials: true,
    timeout: 20000,
    ...config,
  });
  attachAuthInterceptor(client);
  return client;
}

export default axios;
